if (typeof GRAPHQLHOST === 'undefined') {
  const GRAPHQLHOST = 'https://cam-eivy.ddns.net/casapi';
}

let filterObj = {
  url: window.location.href,
  categorySelectedValue: '',
  seriesSelectedValue: '',
  brandSelectedValue: '',
  modelSelectedValue: '',
  colourSelectedValue: '',
  capacitySelectedValue: '',
  sizeSelectedValue: '',
  cosmeticGradingSelectedValue: '',
  buildUrl: ''
};

const brandFilters = document.querySelectorAll('.brands-filter');
const categoryFilters = document.querySelectorAll('.category-filter');
const seriesFilters = document.querySelectorAll('.series-filter');
const modelFilters = document.querySelectorAll('.models-filter');
const colorFilters = document.querySelectorAll('.colors-filter');
const capacityFilters = document.querySelectorAll('.capacity-filter');
const cosmeticGradingFilters = document.querySelectorAll('.cosmetic_grading-filter');
const sizeFilters = document.querySelectorAll('.size-filter');

const clearFilter = document.querySelectorAll('.collection__mobile-active-clear');
const resetFilter = document.querySelector('#mobile-collection-filters .collection-drawer__header button');

const brandSelectedLabel = document.querySelector('.pa_brands_filter_selected');
const categorySelectedLabel = document.querySelector('.pa_category_filter_selected');
const seriesSelectedLabel = document.querySelector('.pa_series_filter_selected');
const modelSelectedLabel = document.querySelector('.pa_models_filter_selected');
const colourSelectedLabel = document.querySelector('.pa_color_filter_selected');
const capacitySelectedLabel = document.querySelector('.pa_capacity_filter_selected');
const sizeSelectedLabel = document.querySelector('.pa_size_filter_selected');
const cosmeticGradingSelectedLabel = document.querySelector('.pa_cosmetic_grading_filter_selected');

/* window.onbeforeunload = function(event) {
  localStorage.setItem('filter', JSON.stringify(filterObj));
};

window.onload = function() {
  filterObj = JSON.parse(localStorage.getItem('filter') || JSON.stringify(filterObj));
}; */

Array.from(brandFilters).forEach(button => {
  button.addEventListener('change', () => {
    if (button.checked) {
      document.querySelectorAll('.brands-filter[data-tag-user]:not([data-tag-user="' + button.dataset.tagUser + '"])').forEach(v => {
        if (button.dataset.tagUser != v.dataset.tagUser) {
          v.checked = false;
          v.classList.remove('is-selected');

          const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '_');
          if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
          }
        }
      });

      setFilterLabel(button, 'brands');
      showTagSelected(button.dataset.tag, button.dataset.tagUser);

      button.classList.add('is-selected');
    } else {
      button.classList.remove('is-selected');
      setFilterLabel('', 'brands');

      const nonSpaceTag = button.dataset.tag.toLowerCase().replace(' ', '_');
      if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
        document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
      }
    }

    buildUrlFilterString(button.dataset.tag);
    getAvailableSeriesTags(true);
    getAvailableModelTags(true);
    productCount();
  });
});
attachCategoryEvent();
attachSeriesEvent();
attachModelEvent();
Array.from(colorFilters).forEach(button => {
  button.addEventListener('change', () => {
    if (button.checked) {
      document.querySelectorAll('input[name="tag-colour"][data-tag-user]:not([data-tag-user="' + button.dataset.tagUser + '"])').forEach(v => {
        if (button.dataset.tagUser != v.dataset.tagUser) {
          v.checked = false;
          v.classList.remove('is-selected');

          const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '_');
          if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
          }
        }
      });

      setFilterLabel(button, 'colour');
      if (button.dataset.tagUser != 'All') {
        showTagSelected(button.dataset.tag, button.dataset.tagUser);
        document.querySelector('#color-tag-all').disabled = false;
      } else {
        document.querySelector('#color-tag-all').disabled = true;
      }
      // buildUrlFilterString(button.dataset.tag);

      button.classList.add('is-selected');
    } else {
      if (button.dataset.tagUser != 'All') {
        button.classList.remove('is-selected');

        const tagAll = document.querySelector('#color-tag-all');
        tagAll.checked = true;
        tagAll.classList.add('is-selected');
        setFilterLabel(tagAll, 'colour');
        document.querySelector('#color-tag-all').disabled = true;
        const nonSpaceTag = button.dataset.tag.toLowerCase().replace(' ', '_');
        if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
          document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
        }
        // buildUrlFilterString(button.dataset.tag);
      }
    }

    buildUrlFilterString(button.dataset.tag);
    productCount();
  });
});
Array.from(capacityFilters).forEach(button => {
  button.addEventListener('change', () => {
    if (button.checked) {
      document.querySelectorAll('input[name="tag-capacity"][data-tag-user]:not([data-tag-user="' + button.dataset.tagUser + '"])').forEach(v => {
        if (button.dataset.tagUser != v.dataset.tagUser) {
          v.checked = false;
          v.classList.remove('is-selected');

          const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '_');
          if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
          }
        }
      });

      setFilterLabel(button, 'capacity');
      if (button.dataset.tagUser != 'All') {
        showTagSelected(button.dataset.tag, button.dataset.tagUser);
        document.querySelector('#capacity-tag-all').disabled = false;
      } else {
        document.querySelector('#capacity-tag-all').disabled = true;
      }
      // buildUrlFilterString(button.dataset.tag);

      button.classList.add('is-selected');
    } else {
      if (button.dataset.tagUser != 'All') {
        button.classList.remove('is-selected');

        const tagAll = document.querySelector('#capacity-tag-all');
        tagAll.checked = true;
        tagAll.classList.add('is-selected');
        setFilterLabel(tagAll, 'capacity');
        document.querySelector('#capacity-tag-all').disabled = true;
        const nonSpaceTag = button.dataset.tag.toLowerCase().replace(' ', '_');
        if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
          document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
        }
        // buildUrlFilterString(button.dataset.tag);
      }
    }

    buildUrlFilterString(button.dataset.tag);
    productCount();
  });
});
Array.from(sizeFilters).forEach(button => {
  button.addEventListener('change', () => {
    const replacementStr = '\\"';
    const replaceDQString = button.dataset.tagUser.replace('"', '\"');
    if (button.checked) {
      document.querySelectorAll('input[name="tag-size"][data-tag-user]:not([data-tag-user=\'' + replaceDQString + '\'])').forEach(v => {
        if (replaceDQString != v.dataset.tagUser.replace(/"/g, replacementStr)) {
          v.checked = false;
          v.classList.remove('is-selected');

          const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '_');
          if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
          }
        }
      });

      setFilterLabel(button, 'size');
      if (replaceDQString != 'All') {
        showTagSelected(button.dataset.tag, replaceDQString);
        document.querySelector('#size-tag-all').disabled = false;
      } else {
        document.querySelector('#size-tag-all').disabled = true;
      }
      // buildUrlFilterString(button.dataset.tag);

      button.classList.add('is-selected');
    } else {
      if (replaceDQString != 'All') {
        button.classList.remove('is-selected');

        const tagAll = document.querySelector('#size-tag-all');
        tagAll.checked = true;
        tagAll.classList.add('is-selected');
        setFilterLabel(tagAll, 'size');
        document.querySelector('#size-tag-all').disabled = true;
        const nonSpaceTag = button.dataset.tag.toLowerCase().replace(' ', '_');
        if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
          document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
        }
        // buildUrlFilterString(button.dataset.tag);
      }
    }

    buildUrlFilterString(button.dataset.tag);
    productCount();
  });
});
Array.from(cosmeticGradingFilters).forEach(button => {
  button.addEventListener('change', () => {
    if (button.checked) {
      document.querySelectorAll('input[name="tag-cosmetic-grading"][data-tag-user]:not([data-tag-user="' + button.dataset.tagUser + '"])').forEach(v => {
        if (button.dataset.tagUser != v.dataset.tagUser) {
          v.checked = false;
          v.classList.remove('is-selected');

          const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '_');
          if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
          }
        }
      });

      setFilterLabel(button, 'cosmetic_grading');
      if (button.dataset.tagUser != 'All') {
        showTagSelected(button.dataset.tag, button.dataset.tagUser);
        document.querySelector('#cosmetic_grading-tag-all').disabled = false;
      } else {
        document.querySelector('#cosmetic_grading-tag-all').disabled = true;
      }
      // buildUrlFilterString(button.dataset.tag);

      button.classList.add('is-selected');
    } else {
      if (button.dataset.tagUser != 'All') {
        button.classList.remove('is-selected');

        const tagAll = document.querySelector('#cosmetic_grading-tag-all');
        tagAll.checked = true;
        tagAll.classList.add('is-selected');
        setFilterLabel(tagAll, 'cosmetic_grading');
        document.querySelector('#cosmetic_grading-tag-all').disabled = true;
        const nonSpaceTag = button.dataset.tag.toLowerCase().replace(' ', '_');
        if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
          document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
        }
        // buildUrlFilterString(button.dataset.tag);
      }
    }

    buildUrlFilterString(button.dataset.tag);
    productCount();
  });
});

document.getElementById('pa_apply_filter_btn').addEventListener('click', (evt) => {
  buildUrlFilterString('');
  let fullUrl = '';
  if (filterObj.url) {
    let path = window.location.pathname.split('/').filter(v => v != '');
    fullUrl = window.location.protocol + '//' + window.location.hostname + '/' + path[0] + '/' + path[1] + '/' + filterObj.buildUrl;

    // TODO: CHECK ISSUE HERE
    let rangeInput = document.querySelectorAll(".price-field input");
    if (rangeInput && rangeInput.length > 0) {
      if (rangeInput[0].value != 0 || rangeInput[1].value != rangeInput[1].dataset.maxValue) {
        if (fullUrl.includes('?')) {
          fullUrl += '&filter.v.price.gte=' + rangeInput[0].value + '&filter.v.price.lte=' + rangeInput[1].value;
        } else {
          fullUrl += '?filter.v.price.gte=' + rangeInput[0].value + '&filter.v.price.lte=' + rangeInput[1].value;
        }
      }
    }

    fullUrl = new URL(fullUrl);
    window.location.href = fullUrl.toString();
  }
});

if (clearFilter) {
  clearFilter.forEach(clearBtn => {
    clearBtn.addEventListener('click', () => {
      const clearFilter = document.querySelector('.collection__mobile-active-clear');
      const resetFilter = document.querySelector('#mobile-collection-filters .collection-drawer__header button');
      if (resetFilter) {
        resetFilter.style.display = 'none';
      }
      clearBtn.style.display = 'none';

      document.querySelectorAll('.collection-drawer__footer [class*="pa_js_tag-models"]').forEach(v => {
        if (v) {
          v.remove();
        }
      })
      const colorFilters = document.querySelector('#color-tag-all');
      const capacityFilters = document.querySelector('#capacity-tag-all');
      // const categoryFilters = document.querySelector('#category-tag-all');
      const cosmeticGradingFilters = document.querySelector('#cosmetic_grading-tag-all');
      const sizeFilters = document.querySelector('#size-tag-all');

      setFilterLabel('', 'category');
      setFilterLabel(capacityFilters, 'capacity');
      setFilterLabel(sizeFilters, 'size');
      setFilterLabel(colorFilters, 'colour');
      setFilterLabel(cosmeticGradingFilters, 'cosmetic_grading');
      setFilterLabel('', 'brands');
      setFilterLabel('', 'series');
      setFilterLabel('', 'models');

      document.querySelector('.pa_colour_filter_selected').style.display = 'block !important';
      document.querySelector('.pa_capacity_filter_selected').style.display = 'block !important';
      document.querySelector('.pa_category_filter_selected').style.display = 'block !important';
      document.querySelector('.pa_cosmetic_grading_filter_selected').style.display = 'block !important';
      document.querySelector('.pa_size_filter_selected').style.display = 'block !important';
      document.querySelector('.pa_series_filter_selected').style.display = 'block !important';
      document.querySelector('.pa_brands_filter_selected').style.display = 'block !important';
      // categoryFilters.checked = true;
      // categoryFilters.classList.add('is-selected');
      capacityFilters.checked = true;
      capacityFilters.classList.add('is-selected');
      sizeFilters.checked = true;
      sizeFilters.classList.add('is-selected');
      colorFilters.checked = true;
      colorFilters.classList.add('is-selected');
      cosmeticGradingFilters.checked = true;
      cosmeticGradingFilters.classList.add('is-selected');

      let newUrl = '';
      const pathName = window.location.pathname.split('/').filter(v => v != '');
      const collectionUrl = window.location.protocol + '//' + window.location.hostname + '/' + pathName[0] + '/' + pathName[1];
      newUrl = new URL(collectionUrl);
      newUrl.searchParams.delete('filter.v.price.lte');
      newUrl.searchParams.delete('filter.v.price.gte');
      window.location.href = newUrl.toString();
    });
  });
}
if (resetFilter) {
  resetFilter.addEventListener('click', () => {
    const clearFilter = document.querySelector('.collection__mobile-active-clear');
    const resetFilter = document.querySelector('#mobile-collection-filters .collection-drawer__header button');
    if (clearFilter) {
      clearFilter.style.display = 'none';
    }
    resetFilter.style.display = 'none';

    document.querySelectorAll('.collection-drawer__footer [class*="pa_js_tag-models"]').forEach(v => {
      if (v) {
        v.remove();
      }
    })
    const colorFilters = document.querySelector('#color-tag-all');
    const capacityFilters = document.querySelector('#capacity-tag-all');
    // const categoryFilters = document.querySelector('#category-tag-all');
    const cosmeticGradingFilters = document.querySelector('#cosmetic_grading-tag-all');
    const sizeFilters = document.querySelector('#size-tag-all');

    setFilterLabel('', 'category');
    setFilterLabel(capacityFilters, 'capacity');
    setFilterLabel(sizeFilters, 'size');
    setFilterLabel(colorFilters, 'colour');
    setFilterLabel(cosmeticGradingFilters, 'cosmetic_grading');
    setFilterLabel('', 'brands');
    setFilterLabel('', 'series');
    setFilterLabel('', 'models');

    document.querySelector('.pa_colour_filter_selected').style.display = 'block !important';
    document.querySelector('.pa_capacity_filter_selected').style.display = 'block !important';
    document.querySelector('.pa_category_filter_selected').style.display = 'block !important';
    document.querySelector('.pa_cosmetic_grading_filter_selected').style.display = 'block !important';
    document.querySelector('.pa_size_filter_selected').style.display = 'block !important';
    document.querySelector('.pa_series_filter_selected').style.display = 'block !important';
    document.querySelector('.pa_brands_filter_selected').style.display = 'block !important';
    capacityFilters.checked = true;
    capacityFilters.classList.add('is-selected');
    sizeFilters.checked = true;
    sizeFilters.classList.add('is-selected');
    colorFilters.checked = true;
    colorFilters.classList.add('is-selected');
    cosmeticGradingFilters.checked = true;
    cosmeticGradingFilters.classList.add('is-selected');

    let newUrl = '';
    const pathName = window.location.pathname.split('/').filter(v => v != '');
    const collectionUrl = window.location.protocol + '//' + window.location.hostname + '/' + pathName[0] + '/' + pathName[1];
    newUrl = new URL(collectionUrl);
    newUrl.searchParams.delete('filter.v.price.lte');
    newUrl.searchParams.delete('filter.v.price.gte');
    window.location.href = newUrl.toString();
  });
}

async function productCount() {
  const applyBtn = document.getElementById('pa_apply_filter_btn');
  let productDataCount = 0;
  let products = await getProducts();
  let tags = [];

  Array.from(document.querySelectorAll('.capacity-filter.is-selected'))
  .concat(Array.from(document.querySelectorAll('.cosmetic_grading-filter.is-selected')))
  .concat(Array.from(document.querySelectorAll('.size-filter.is-selected')))
  .concat(Array.from(document.querySelectorAll('.colors-filter.is-selected')))
  .forEach(checkbox => {
    if (checkbox.checked && checkbox.dataset.tag && checkbox.dataset.tag != 'All') {
      tags.push(checkbox.dataset.tag);
    }
  });

  const selectedOptions = tags.reduce((acc, tag) => {
    for (const [prefix, optionName] of Object.entries({
      "capacity_": "Capacity",
      "size_": "Size",
      "cosmetic-grading_": "Cosmetic Grading",
      "colour_": "Colour",
    })) {
      if (tag.startsWith(prefix)) {
        // Remove prefix and handle case sensitivity
        let formattedValue = tag.replace(prefix, '');
        if (optionName == 'Colour') {
          formattedValue = formattedValue.split('_').pop().replace(/-/g, ' ').toLowerCase();
        } else {
          formattedValue = formattedValue.split('_').pop().replace(/-/g, '').toLowerCase();
        }

        acc[optionName] = formattedValue;
      }
    }
    return acc;
  }, {});

  if (tags.length > 0) {
    products.edges = products.edges.filter(product => 
      product.node.variants.edges.some(variant => {
        const hasAllRequiredOptions = Object.entries(selectedOptions).every(([optionName, optionValue]) =>
          variant.node.selectedOptions.some(option => {
            const cleanedVarOptionName = option.name.replace(/color/i,'Colour'); // Standardize color as Colour
            const cleanedVarOptionVal = option.value.toLowerCase().replace(/\b(?:1gb|2gb|3gb|4gb|6gb|8gb|12gb|16gb|24gb|32gb|64gb)\//gi, '');
            return cleanedVarOptionName === optionName && cleanedVarOptionVal === optionValue;
          })
        );
        return hasAllRequiredOptions && variant.node.sellableOnlineQuantity > 0;
      })
    );
  }

  productDataCount = products.edges.length;
  // TEMPORARILY DISABLE THIS LOGIC UNTIL ADVANCE FILTER COUNT ISSUE RESOLVED
  // applyBtn.innerText = 'View results';
  if (productDataCount) {
    applyBtn.disabled = false;
    applyBtn.innerText = 'Show ' + productDataCount + (productDataCount > 1 ? ' items' : ' item');
  } else {
    applyBtn.disabled = true;
    applyBtn.innerText = 'Show 0 item';
  }
}

async function getAvailableSeriesTags(cleanup = false) {
  const series = 'pa_series_container', availableSeries = [];
  let htmlElement = document.querySelector('.'+series+' > ul');
  const collection = document.querySelector('#main section').dataset.collection;
  const selectedCategory = document.querySelector('.category-filter.is-selected');
  const bFilters = document.querySelector('.brands-filter.is-selected');

  if (!htmlElement) {
    return;
  }

  let gqlParams = "status:active";

  if (bFilters && bFilters.dataset.tagUser) {
    gqlParams += ' AND vendor:' + bFilters.dataset.tagUser;
  }

  const collectionConditionQuery = await getCollectionConditions();
  if (collectionConditionQuery && selectedCategory && selectedCategory.dataset.tagUser != 'All') {
    gqlParams += " AND " + collectionConditionQuery;
  }

  if (selectedCategory && selectedCategory.dataset.tagUser != 'All') {
    gqlParams += " AND product_type:'" + categorySpecialFilter(selectedCategory.dataset.tagUser) + "'";
  }
  const query = `
    {
      products(
        query: "${gqlParams}"
        first: 250
      ) {
        nodes {
          tags
        }
      }
    }
  `;

  const response = await fetch(GRAPHQLHOST, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query }),
  });

  const result = await response.json();
  const data = result.data.products.nodes;

  while (htmlElement.firstChild) { 
    htmlElement.removeChild(htmlElement.firstChild);
  }
  if (cleanup) {
    setFilterLabel('', 'series');
    const selectedTagToRemove = document.querySelector('.collection-drawer__footer [class*="pa_js_tag-models"]')
    if (selectedTagToRemove) {
      selectedTagToRemove.remove();
    }
  }

  data.forEach(v => {
    let currentSeries = '';
    v.tags.forEach(y => {
      if (y.toLowerCase().includes('models_')) {
        currentSeries = y;
      }
    });
    availableSeries.push(currentSeries);
  });

  const temp = availableSeries.filter((v, k, arr) => arr.indexOf(v) === k).filter(v => v != '').sort();
  htmlElement.insertAdjacentHTML('beforeend', `<li class="collection__filter-checkbox">
      <label for="series-tag-all">
        <input type="checkbox" class="checkbox series-filter" id="series-tag-all" name="tag-series" data-tag="" data-tag-user="All">
        <span class="tag-all">All</span>
      </label>
    </li>`);
  const series_sequence_order = new Array(
    "iPhone15Series",
    "iPhone14Series",
    "iPhone13Series",
    "iPhone12Series",
    "iPhone11Series",
    "iPhoneSESeries",
    "iPhoneXRSeries",
    "iPhoneXSSeries",
    "iPhoneXSeries",
    "iPhone8Series",
    "iPhone7Series",
    "GalaxyS24Series",
    "GalaxyS23Series",
    "GalaxyS22Series",
    "GalaxyS21Series",
    "GalaxyS20Series",
    "GalaxyS10Series",
    "GalaxyNoteSeries",
    "GalaxyASeries",
    "GalaxyZFlipSeries",
    "GalaxyZFoldSeries",
    "XiaomiSeries",
    "BlackSharkSeries",
    "MiSeries",
    "PocoSeries",
    "RedmiSeries",
    "RenoSeries",
    "FindSeries",
    "ASeries",
    "MateSeries",
    "NovaSeries",
    "PSeries",
    "YSeries",
    "iPad",
    "iPadAir",
    "iPadMini",
    "iPadPro",
    "GalaxyTabSSeries",
    "GalaxyTabASeries",
    "WatchSeries9",
    "WatchSeries8",
    "WatchSeries7",
    "WatchSeries6",
    "WatchSeries5",
    "WatchSeries4",
    "WatchSeries3",
    "WatchSeries2",
    "WatchSeriesSE",
    "WatchSeriesUltra",
    "GalaxyWatch6",
    "GalaxyWatch5",
    "GalaxyWatch4",
    "GalaxyWatch3",
    "GalaxyWatchActive",
    "GalaxyWatch6",
    "MacMini",
    "MacStudio",
    "MacbookAir",
    "MacbookPro"
  );
  temp.forEach(v => {
    const readableTag = v.split('_');
    let indexOfSequence = 0;
    if (series_sequence_order.indexOf(readableTag[readableTag.length-1].replaceAll(' ', '')) != -1) {
      indexOfSequence = series_sequence_order.indexOf(readableTag[readableTag.length-1].replaceAll(' ', ''));
    } else {
      // For series that does not exist inside the sequence, order it as least prioratized
      indexOfSequence = series_sequence_order.length + 1;
    }
    let correctFormatting = v.toLowerCase().replaceAll(' ', '-');
    let template = `<li class="collection__filter-checkbox" style="order: ${indexOfSequence + 5}">
      <label for="${series}-tag-${correctFormatting}">
        <input type="checkbox" class="checkbox series-filter" id="${series}-tag-${correctFormatting}" name="tag-models" data-tag="${correctFormatting}" data-tag-user="${readableTag[readableTag.length-1]}">
        <span class="${series}-tag-${correctFormatting}">${readableTag[readableTag.length-1]}</span>
      </label>
    </li>`;
    htmlElement.insertAdjacentHTML('beforeend', template);
  });
  attachSeriesEvent();

  document.querySelectorAll('.collection-drawer__footer .collection__mobile-active-filters > button').forEach(v => {
    const selectReplaceElem = document.querySelector('.pa_series_container [data-tag="' + v.dataset.tag + '"]');
    if (selectReplaceElem) {
      selectReplaceElem.checked = true;
      selectReplaceElem.classList.add('is-selected');
      setFilterLabel(selectReplaceElem, 'series');
    }
  });
}

async function getAvailableModelTags(cleanup = false) {
  const models = 'pa_models_container', availableModels = [];
  let htmlElement = document.querySelector('.'+models+' > ul');
  const collection = document.querySelector('#main section').dataset.collection;
  const selectedCategory = document.querySelector('.category-filter.is-selected');
  const selectedSeries = document.querySelector('.series-filter.is-selected');
  const selectedSeriesNotall = document.querySelector('.series-filter.is-selected[data-tag-user="All"]');

  if (!htmlElement) {
    return;
  }

  let data = [];
  if (selectedSeries.dataset.tagUser != 'All') {
    let gqlParams = "status:active AND published_status:published AND collection:'" + collection + "'";
    if (selectedCategory && selectedCategory.dataset.tagUser != 'All') {
      gqlParams += " AND product_type:'" + categorySpecialFilter(selectedCategory.dataset.tagUser) + "'";
    }
    if (selectedSeries && selectedSeries.dataset.tag) {
      gqlParams += ' AND tag:' + selectedSeries.dataset.tag;
    }
  
    const query = `
      {
        products(
          query: "${gqlParams}"
          first: 250
        ) {
          nodes {
            id
            tags
          }
        }
      }
    `;
  
    const response = await fetch(GRAPHQLHOST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });
  
    const result = await response.json();
    data = result.data.products.nodes;
  }

  while (htmlElement.firstChild) { 
    htmlElement.removeChild(htmlElement.firstChild);
  }
  if (cleanup) {
    setFilterLabel('', 'models');
    const selectedTagToRemove = document.querySelector('.collection-drawer__footer [class*="pa_js_tag-models2"]')
    if (selectedTagToRemove) {
      selectedTagToRemove.remove();
    }
  }

  data.forEach(v => {
    let currentModel = '';
    v.tags.forEach(y => {
      if (y.toLowerCase().includes('models2_')) {
        currentModel = y;
      }
    });
    availableModels.push(
      {
        "id": v.id,
        "tag": currentModel
      }
    );
  });

  const temp = availableModels.filter(model => model.tag !== "").sort((a, b) => a.tag.localeCompare(b.tag));
  if (!temp.length || selectedSeriesNotall) {
    document.querySelector('.pa_models_container').classList.add('pa-disabled');
    return;
  } else {
    document.querySelector('.pa_models_container').classList.remove('pa-disabled');
  }
  htmlElement.insertAdjacentHTML('beforeend', `<li class="collection__filter-checkbox">
      <label for="models-tag-all">
        <input type="checkbox" class="checkbox models-filter" id="models-tag-all" name="tag-models" data-tag="" data-tag-user="All">
        <span class="tag-all">All</span>
      </label>
    </li>`);
  temp.forEach(v => {
    const readableTag = v.tag.split('_');
    let correctFormatting = v.tag.toLowerCase().replaceAll(' ', '-').replaceAll(/[\])}[{(]/g, '').replace('"', '');
    let readableTagFormat = readableTag[readableTag.length-1].replaceAll(/[\])}[{(]/g, '').replace('"', '\\"');
    let productId  = v.id;
    let template = `<li class="collection__filter-checkbox">
      <label for="${models}-tag-${correctFormatting}">
        <input type="checkbox" class="checkbox models-filter" id="${models}-tag-${correctFormatting}" name="tag-models" data-tag="${correctFormatting}" data-tag-user="${readableTagFormat}" data-product-id="${productId}">
        <span class="${models}-tag-${correctFormatting}">${readableTagFormat}</span>
      </label>
    </li>`;
    htmlElement.insertAdjacentHTML('beforeend', template);
  });
  attachModelEvent();

  document.querySelectorAll('.collection-drawer__footer .collection__mobile-active-filters > button').forEach(v => {
    const selectReplaceElem = document.querySelector('.pa_models_container [data-tag="' + v.dataset.tag + '"]');
    if (selectReplaceElem) {
      selectReplaceElem.checked = true;
      selectReplaceElem.classList.add('is-selected');
      setFilterLabel(selectReplaceElem, 'models');
    }
  });
}

async function getCollectionConditions() {
  let queryStr = "";
  const collection = document.querySelector('#main section').dataset.collection;

  if (collection) {
    let gqlParams = 'title:' + collection;
    const query = `
      {
        collections(
          query: "${gqlParams}"
          first: 250
        ) {
          nodes {
            ruleSet {
              appliedDisjunctively
              rules {
                column
                condition
                conditionObject {
                  ... on CollectionRuleTextCondition {
                    value
                  }
                }
                relation
              }
            }
          }
        }
      }
    `;

    const response = await fetch(GRAPHQLHOST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    const result = await response.json();
    const data = result.data.collections.nodes[0].ruleSet;

    if (data && isRuleAvailable(data.rules)) {
      // Collection type: Automated 
      const condition = result.data.collections.nodes[0].ruleSet?.appliedDisjunctively;
      const queryParts = data.rules.map((rule) => {
        const operator = getConditionOperator(rule);

        if (!operator) {
          return '';
        }

        // Determine if finalVal needs quotation mark around it
        const finalVal = !isNaN(rule.conditionObject.value) && !isNaN(parseFloat(rule.conditionObject.value)) 
          ? rule.conditionObject.value // Dont add 'quote' around value
          : "'" + rule.conditionObject.value + "'"; // Add 'quote' quote around value

        return `${operator}${finalVal}`;
      });
    
      const separator = condition ? " OR " : " AND ";
      const queryStr = queryParts.filter(part => part).join(separator); // Filter out empty strings and then join

      return queryStr;
    } else {
      // Collection type `Manual` or collection rule is not available
      let product_ids = await getProductIdsFromCollection(collection);
      queryStr = "id:" + product_ids.join(" OR id:");
      return queryStr;
    }
  }
}

async function getProductIdsFromCollection(collection) {
  let product_ids = [];
  let hasNextPage = true;
  let endCursor = null;

  while (hasNextPage) {
    const query = `
      {
        collections(
          query: "title:${collection}"
          first: 1
        ) {
          nodes {
            products(first: 100${endCursor ? `, after: "${endCursor}"` : ''}) {
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    `;

    const response = await fetch(GRAPHQLHOST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    const result = await response.json();
    const data = result.data.collections.nodes[0].products;
    const products = data.edges;

    products.forEach((product) => {
      product_ids.push(product.node.id.split("/").pop());
    });

    hasNextPage = data.pageInfo.hasNextPage;
    endCursor = data.pageInfo.endCursor;
  }

  return product_ids;
}

if (typeof renameColumn === 'undefined') {
  const renameColumn = (column) => {
    switch (column) {
      case "VARIANT_PRICE":
        return "price";
      case "TITLE":
        return "title";
      case "TYPE":
        return "product_type";
      case "VENDOR":
        return "vendor";
      case "TAG":
        return "tag";
      default:
        return false;
    }
  };
};

if (typeof getConditionOperator === 'undefined') {
  const getConditionOperator = (rule) => {
    var filterName = renameColumn(rule.column);
  
    switch (rule.relation) {
      case "EQUALS":
        return `${filterName}:`;
      case "NOT_EQUALS":
        return `-${filterName}:`;
      case "GREATER_THAN":
        return `${filterName}:>=`;
      case "LESS_THAN":
        return `${filterName}:<=`;
    }
  
    return false;
  };
};

if (typeof isRuleAvailable === 'undefined') {
  const isRuleAvailable = (data) => {
    // Below collection condition cannot be used inside product's query
    const columnsToCheck = ["TITLE", "VARIANT_COMPARE_AT_PRICE", "VARIANT_WEIGHT", "VARIANT_TITLE"];
    const relationsToCheck = ["STARTS_WITH", "ENDS_WITH", "CONTAINS", "NOT_CONTAINS"];
  
    for (const rule of data) {
      if (columnsToCheck.includes(rule.column) || relationsToCheck.includes(rule.relation)) {
        return false;
      }
    }
    return true;
  };
};

async function getProducts() {
  const selectedModel = document.querySelector('.models-filter.is-selected[data-tag-user]:not([data-tag-user="All"])');
  let collectionCondition = await getCollectionConditions();
  let query = getQueryString();

  if (collectionCondition) {
    query += ' AND ' + collectionCondition;
  }

  if (selectedModel) {
    query += ' id:' + selectedModel.dataset.productId.replace(/\D/g, '');
  }

  const modelQuery = `
    {
      products(
        query: "${query}"
        first: 250
      ) {
        edges {
          node {
            id
            title
            variants(first: 60) {
              edges {
                node {
                  id
                  title
                  sellableOnlineQuantity
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const modelResponse = await fetch(GRAPHQLHOST, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query: modelQuery }),
  });
  const modelResult = await modelResponse.json();
  return modelResult.data.products;
}

function getQueryString() {
  let query = 'status:active AND published_status:published';
  const collection = document.querySelector('#main section').dataset.collection;

  const bFilters = document.querySelector('.brands-filter.is-selected');
  if (bFilters && bFilters.dataset.tagUser) {
    query += ' AND vendor:' + bFilters.dataset.tagUser;
  }

  let newProductType = [];
  document.querySelectorAll('.category-filter.is-selected').forEach(checkbox => {
    if (checkbox.checked && checkbox.dataset.tagUser != 'All') {
      newProductType.push(categorySpecialFilter(checkbox.dataset.tagUser));
      query += " AND tag:'" + checkbox.dataset.tag + "'";
    }
  });
  if (newProductType.length) {
    query += " AND product_type:\'" + newProductType.join(',') + "'";
  }

  Array.from(document.querySelectorAll('.series-filter.is-selected'))
    .concat(Array.from(document.querySelectorAll('.models-filter.is-selected')))
    .concat(Array.from(document.querySelectorAll('.capacity-filter.is-selected')))
    .concat(Array.from(document.querySelectorAll('.cosmetic_grading-filter.is-selected')))
    .concat(Array.from(document.querySelectorAll('.size-filter.is-selected')))
    .concat(Array.from(document.querySelectorAll('.colors-filter.is-selected')))
    .forEach(checkbox => {
    if (checkbox.checked && checkbox.dataset.tag && checkbox.dataset.tag != 'All') {
      query += ' AND tag:' + checkbox.dataset.tag;
    }
  });

  document.querySelectorAll(".range-input input").forEach(v => {
    if (v.value && v.classList.contains('min-range')) {
      query += ' AND price:>=' + v.value;
    } else if (v.value && v.classList.contains('max-range')) {
      query += ' AND price:<=' + v.value;
    }
  });

  resetFilter.style.display = 'block';
  return query;
}

function categorySpecialFilter(selectedValue) {
  if (selectedValue == 'Smartphones') {
    return 'Smartphone';
  } else if (selectedValue == 'Smartwatch') {
    return 'smart watch';
  } else {
    return selectedValue;
  }
}

function buildUrlFilterString(url) {
  const noSpaceUrl = url.replace(' ', '-');
  let constructUrl = '';

  document.querySelectorAll('.collection__filter-checkbox-list .is-selected, .collection__filter-color-list .is-selected').forEach(v => {
    if (v.dataset.tagUser != 'All') {
      if (constructUrl == '') {
        constructUrl = v.dataset.tag;
      } else {
        constructUrl += '+' + v.dataset.tag;
      }
    }
  });
  filterObj.buildUrl = constructUrl;
}

function attachCategoryEvent() {
  const categoryFilters = document.querySelectorAll('.category-filter');
  Array.from(categoryFilters).forEach(button => {
    button.addEventListener('change', () => {
      if (button.checked) {
        document.querySelectorAll('input[name="tag-category"][data-tag-user]:not([data-tag-user="' + button.dataset.tagUser + '"])').forEach(v => {
          if (button.dataset.tagUser != v.dataset.tagUser) {
            v.checked = false;
            v.classList.remove('is-selected');

            const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '_');
            if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
              document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
            }
          }
        });

        setFilterLabel(button, 'category');
        if (button.dataset.tagUser != 'All') {
          showTagSelected(button.dataset.tag, button.dataset.tagUser);
          // document.querySelector('#category-tag-all').disabled = false;
        } else {
          // document.querySelector('#category-tag-all').disabled = true;
        }

        button.classList.add('is-selected');
      } else {
        if (button.dataset.tagUser != 'All') {
          button.classList.remove('is-selected');

          // const tagAll = document.querySelector('#category-tag-all');
          // tagAll.checked = true;
          // tagAll.classList.add('is-selected');
          // tagAll.disabled = true;
          setFilterLabel('', 'category');
          const nonSpaceTag = button.dataset.tag.toLowerCase().replace(' ', '_');
          if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
          }
        }
      }

      buildUrlFilterString(button.dataset.tag);
      getAvailableSeriesTags(true);
      getAvailableModelTags(true);
      productCount();
    });
  });
}
function attachSeriesEvent() {
  const seriesFilters = document.querySelectorAll('.series-filter');
  Array.from(seriesFilters).forEach(button => {
    button.addEventListener('change', () => {
      if (button.checked) {
        document.querySelectorAll('.series-filter[data-tag-user]:not([data-tag-user="' + button.dataset.tagUser + '"])').forEach(v => {
          if (button.dataset.tagUser != v.dataset.tagUser) {
            v.checked = false;
            v.classList.remove('is-selected');

            const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '_');
            if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
              document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
            }
          }
        });

        setFilterLabel(button, 'series');
        if (button.dataset.tagUser != 'All') {
          showTagSelected(button.dataset.tag, button.dataset.tagUser);
          document.querySelector('#series-tag-all').disabled = false;
        } else {
          document.querySelector('#series-tag-all').disabled = true;
        }

        button.classList.add('is-selected');
      } else {
        if (button.dataset.tagUser != 'All') {
          button.classList.remove('is-selected');
          setFilterLabel('', 'series');

          const nonSpaceTag = button.dataset.tag.toLowerCase().replace(' ', '_');
          if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
          }
        }
      }

      buildUrlFilterString(button.dataset.tag);
      getAvailableModelTags(true);
      setTimeout(productCount, 600);
    });
  });
}
function attachModelEvent() {
  const modelFilters = document.querySelectorAll('.models-filter');
  Array.from(modelFilters).forEach(button => {
    button.addEventListener('change', () => {
      if (button.checked) {
        document.querySelectorAll('.models-filter[data-tag-user]:not([data-tag-user="' + button.dataset.tagUser + '"])').forEach(v => {
          if (button.dataset.tagUser != v.dataset.tagUser) {
            v.checked = false;
            v.classList.remove('is-selected');

            const nonSpaceTag = v.dataset.tag.toLowerCase().replace(' ', '_');
            if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
              document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
            }
          }
        });

        setFilterLabel(button, 'models');
        if (button.dataset.tagUser != 'All') {
          showTagSelected(button.dataset.tag, button.dataset.tagUser);
          document.querySelector('#models-tag-all').disabled = false;
        } else {
          document.querySelector('#models-tag-all').disabled = true;
        }

        button.classList.add('is-selected');
      } else {
        if (button.dataset.tagUser != 'All') {
          button.classList.remove('is-selected');
          setFilterLabel('', 'models');

          const nonSpaceTag = button.dataset.tag.toLowerCase().replace(' ', '_');
          if (document.querySelector('.pa_js_tag-' + nonSpaceTag)) {
            document.querySelector('.pa_js_tag-' + nonSpaceTag).remove();
          }
        }
      }

      buildUrlFilterString(button.dataset.tag);
      productCount();
    });
  });
}

function showTagSelected(tag, label) {
  const htmlElement = document.querySelector('.collection-drawer__footer .collection__mobile-active-filters');
  let correctFormatting = tag.toLowerCase().replace(' ', '_').replaceAll('&', '\\&');

  let template = `<button type="button" class="collection__mobile-active-filter-item pa_js_tag-${correctFormatting}" data-tag="${correctFormatting}">${label}
    <span class="collection__mobile-active-filter-cross">
      <svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">
        <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
      </svg>
    </span>
  </button>`;
  htmlElement.insertAdjacentHTML('beforeend', template);
  document.querySelector('.pa_js_tag-' + correctFormatting).addEventListener('click', (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    document.querySelector('.pa_js_tag-' + correctFormatting).remove();
    document.querySelector('.collection-drawer [data-tag="' + tag + '"]').classList.remove('is-selected');
    document.querySelector('.collection-drawer [data-tag="' + tag + '"]').checked = false;

    const tags = tag.split('_');
    if (tags[0] == 'colour') {
      const tagAll = document.querySelector('#color-tag-all');
      tagAll.checked = true;
      tagAll.classList.add('is-selected');
      setFilterLabel(tagAll, 'colour');
    } else {
      const tagAll = document.querySelector('#' + tags[0] + '-tag-all');
      tagAll.checked = true;
      tagAll.classList.add('is-selected');
      setFilterLabel(tagAll, tags[0]);
    }

    productCount();
    if (tags[0] == 'category') {
      getAvailableSeriesTags();
      getAvailableModelTags();
    }
  });
}

function showPriceTagSelected() {
  const htmlElement = document.querySelector('.collection-drawer__footer .collection__mobile-active-filters');
  const minRange = document.querySelector('#filter-price .range-input .min-range');
  const maxRange = document.querySelector('#filter-price .range-input .max-range');
  const priceLabel = document.querySelector('.pa_budget_filter_selected');
  const rangevalue = document.querySelector(".slider-container .price-slider");

  const existingTag = document.querySelector('.collection-drawer__footer .collection__mobile-active-filters .pa_js_tag-budget');
  if (existingTag) {
    existingTag.remove();
  }

  let currency = '';
  if (priceLabel && priceLabel.dataset.currency) {
    currency = priceLabel.dataset.currency;
  }

  let newUrl = new URL(window.location.href);
  newUrl.searchParams.delete('filter.v.price.lte');
  newUrl.searchParams.delete('filter.v.price.gte');
  let pricingTagTemplate = `<button type="button" class="pa_filter_active-facets__button collection__mobile-active-filter-item pa_js_tag-budget">
      ${currency}${pricingFormat(parseFloat(minRange.value))} - ${currency}${pricingFormat(parseFloat(maxRange.value))}
      <span class="collection__mobile-active-filter-cross">
      <svg focusable="false" class="icon icon--close" viewBox="0 0 19 19" role="presentation">
        <path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path>
      </svg>
    </span>
  </button>`;

  htmlElement.insertAdjacentHTML('beforeend', pricingTagTemplate);
  document.querySelector('.pa_js_tag-budget').addEventListener('click', (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    document.querySelector('.pa_js_tag-budget').remove();
    minRange.value = minRange.min;
    maxRange.value = maxRange.max;

    priceLabel.innerText = currency + minRange.value + ' - ' + currency + maxRange.value;
    rangevalue.style.left = `0%`;
    rangevalue.style.right = `100%`;

    productCount();
  });
}

function setFilterLabel(item, category) {
  const allArr = ['series', 'models', 'colour', 'capacity', 'category', 'cosmetic_grading', 'size'];
  const elm = '.pa_' + category + '_filter_selected';
  if (document.querySelector(elm)) {
    if (item) {
      if (item.dataset.tagUser) {
        document.querySelector(elm).innerText = item.dataset.tagUser;
      }
    } else {
      if (allArr.includes(category)) {
        document.querySelector(elm).innerText = 'All';
        let tagAll = '';
        if (category == 'colour') {
          tagAll = document.querySelector('#color-tag-all');
        } else {
          tagAll = document.querySelector('#' + category + '-tag-all');
        }

        if (tagAll) {
          tagAll.checked = true;
          tagAll.classList.add('is-selected');
        }
      } else {
        document.querySelector(elm).innerText = '';
      }
    }
  }
}

function pricingFormat(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function customTagAction() {
  const customTag = document.querySelectorAll('.collection__mobile-active-filter-item');

  if (customTag) {
    customTag.forEach(button => {
      button.addEventListener('click', () => {
        const obj = {
          "models": "series",
          "models2": "models"
        };
        let selectedTag = document.querySelector('.collection__filter-checkbox input[data-tag="' + button.dataset.tag + '"]');
        if (selectedTag) {
          const category = button.dataset.tag.split('_');
          // let newUrl = window.location.href.replace(button.dataset.tag, '');
          // newUrl = window.location.href.split('+').filter(v => v != '').join('+');
          setFilterLabel('', obj[category[0]]);
          document.querySelector('.pa_js_tag-' + button.dataset.tag).remove();

          selectedTag.checked = false;
          selectedTag.classList.remove('is-selected');
          if (category[0] == 'models') {
            const tagAll = document.querySelector('#series-tag-all');
            if (tagAll) {
              tagAll.checked = true;
              tagAll.classList.add('is-selected');
            }
          } else if (category[0] == 'models2') {
            const tagAll = document.querySelector('#models-tag-all');
            if (tagAll) {
              tagAll.checked = true;
              tagAll.classList.add('is-selected');
            }
          } else if (category[0] == 'colour') {
            const tagAll = document.querySelector('#color-tag-all');
            if (tagAll) {
              tagAll.checked = true;
              tagAll.classList.add('is-selected');
            }
          } else {
            const tagAll = document.querySelector('#' + category[0] + '-tag-all');
            if (tagAll) {
              tagAll.checked = true;
              tagAll.classList.add('is-selected');
            }
          }
        }
      });
    });
  }
}